




































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "../threcord/Echarts.vue";
import EchartsHumi from "../threcord/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: Date = new Date();
  snid: string;
  gastype: Number;
}
@Component({
  components: { Echarts, EchartsHumi },
})
export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date }) AddTime: Date;
  @Prop({ type: String }) snid: string;
  @Prop({ type: String }) locationName: number;
  @Prop({ type: Number }) max25: number;
  @Prop({ type: Number }) max10: number;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi: number = 10;
  datalist = [];
  legenddata: string = "";
  xAxisdata: string = "";
  seriesdata: string = "";
  yAxisdata: string = "";
  pm10seriesdata: string = "";
  serieslist = [];
  pm10serieslist = [];
  yAxislist = [];
  thdata: Thdata = new Thdata();
  StartTime: string;
  EndTime: string;
  list = [];
  type = "";
  strtitle: string = "";
  pmtitle: string = "";
  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
    this.pagerequest.AddTime = this.AddTime;
    this.pagerequest.snid = this.snid;
    this.list = await this.$store.dispatch({
      type: "inairdata/getPagedLast",
      data: this.pagerequest,
    });
    //this.ThisThPaged();
    let titlelist = ["气体浓度检测"];

    this.serieslist.push({
      name: "PM2.5浓度",
      type: "line",
      data: [],
      markPoint: {
        data: [],
      },
    });
    this.pm10serieslist.push({
      name: "PM10浓度",
      type: "line",
      data: [],
      markPoint: {
        data: [],
      },
    });
    this.strtitle = "PM2.5浓度走势图";
    this.pmtitle = "PM10浓度走势图";
    let timelist = [];
    let datalist_PM25= [];
    let datalist_PM10 = [];
    let point_temp1 = [];
    let point_temp2 = [];
    console.log(this.max25);
    for (let entry of this.list) {
      timelist.push(this.GetMinutes(entry.addtime));
      if (entry.pM25 > this.max25) {
        point_temp1.push({
          value: entry.pM25,
          xAxis: this.GetMinutes(entry.addtime),
          yAxis: entry.pM25,
        });
      }

      if (entry.pM10 > this.max10) {
        point_temp2.push({
          value: entry.pM10,
          xAxis: this.GetMinutes(entry.addtime),
          yAxis: entry.pM10,
        });
      }

      datalist_PM25.push(entry.pM25);
      datalist_PM10.push(entry.pM10);
    }

    this.serieslist[0].data = datalist_PM25;
    this.pm10serieslist[0].data = datalist_PM10;
    this.serieslist[0].markPoint.data = point_temp1;
    this.pm10serieslist[0].markPoint.data = point_temp2;
    this.legenddata = JSON.stringify(titlelist);
    this.seriesdata = JSON.stringify(this.serieslist);
    this.pm10seriesdata = JSON.stringify(this.pm10serieslist);
    this.xAxisdata = JSON.stringify(timelist);
    this.showEcharts();
  }
  GetMinutes(time) {
    //  console.log(time);
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getHours()) +
      ":" +
      this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetBqMinutes(str) {
    if (str.toString().length == 1) {
      return "0" + str;
    }
    return str;
  }
  visibleChange(value: boolean) {
    // this.ThisThPaged();

    if (!value) {
      this.$emit("input", value);
    } else {
      // this.thdata = Util.extend(
      //   true,
      //   {},
      //   this.$store.state.thdata.analyseThdata
      // );
      //console.log(this.$store.state.thdata.analyseThdata);
      this.getPage();
    }
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi += 1;
  }

  // async ThisThPaged(){
  //  this.list=await this.$store.dispatch({
  //     type:"thdata/getThisThPaged",
  //   });
  //   //return this.list;

  // }
}
